module.exports = __webpack_public_path__ + "img/1.b0835e90.png";